import { CustomState } from "@iewc/Store/Reducers";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {}

const mapStateToProps = (customState: CustomState) => {
    const totalItemCount = customState.blogList.pagination?.totalItemCount;
    return {
        totalItemCount,
    };
};

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

export interface BlogCategoryListCountWidgetStyles {
    wrapper?: InjectableCss;
    countText?: TypographyPresentationProps;
}

export const blogCategoryListCountWidgetStyles: BlogCategoryListCountWidgetStyles = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            min-height: 40px;
        `,
    },
    countText: {
        weight: 700,
    },
};

const styles = blogCategoryListCountWidgetStyles;

const BlogListCount: FC<Props> = ({ totalItemCount }) => {
    if (!totalItemCount) {
        return null;
    }

    const itemsText = totalItemCount !== 1 ? "Posts" : "Post";

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.countText}>
                {totalItemCount} {translate(itemsText)}
            </Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(BlogListCount) as any,
    definition: {
        displayName: "Category List Count",
        group: "Verndale Box - Blog" as any,
        icon: "hashtag",
        allowedContexts: ["BlogCategoryPage" as any],
    },
};

export default widgetModule;
